const updateTheme = (theme) => {
  window.less.modifyVars({...theme});
}

export default updateTheme;

